import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Clock } from 'lucide-react';
export function UrgencyBanner() {
  const [isVisible, setIsVisible] = useState(true);
  const [timeLeft, setTimeLeft] = useState({
    hours: 4,
    minutes: 59,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            ...prev,
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  if (!isVisible) return null;
  return <AnimatePresence data-id="element-216">
      <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: 'auto',
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} className="bg-teal-600 text-white py-2 px-4 relative z-50" data-id="element-217">
        <div className="container mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 text-sm md:text-base font-medium text-center" data-id="element-218">
          <div className="flex items-center gap-2" data-id="element-219">
            <Clock className="w-4 h-4" data-id="element-220" />
            <span data-id="element-221">
              🔥 Oferta por tiempo limitado: 60% de descuento • Solo quedan
              pocas unidades al precio especial
            </span>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>;
}